import React from 'react';
import {AMLToggle} from '../../../components/Toggle';
import {useDispatch, useSelector} from 'react-redux';
import {profileIc} from '../../../assets/images/images';
import SettingsLayout from '../SettingsLayout';
import * as Action from '../../../store/actions';

function Organisation() {
  const {userDetails, loading} = useSelector(state => state?.auth);
  const dispatch = useDispatch();

  const handle2FASetup = value => {
    dispatch(Action?.updateCompanyInfo({two_factor_auth: value}));
  };
  return (
    <SettingsLayout
      pageTitle="Organisation"
      pageIcon={profileIc}
      action={<div className="mt-14" />}
    >
      <div className="grid grid-cols-2 mt-10">
        <div className="">
          <h3 className="text-xs font-medium uppercase text-body">
            2 factor authentication (2fa)
          </h3>
          <div className="p-6 mt-3 bg-white">
            <h3 className="text-sm font-medium  text-body mb-3">
              2FA Authorisation for teams
            </h3>

            <div className="flex items-center justify-between w-[87%]">
              <p className="text-grey-500 text-sm">
                This will{' '}
                {userDetails?.company?.two_factor_auth ? 'disable' : 'enable'}{' '}
                2-Factor authorisation for all your team members
              </p>
              <div className="flex items-center gap-3 relative">
                <AMLToggle
                  isChecked={userDetails?.company?.two_factor_auth}
                  title="This will enable 2-Factor authorisation for you only"
                  onCheck={handle2FASetup}
                />
                {loading && (
                  <div className="absolute flex items-center -bottom-2 right-8 mb-2">
                    <span className="text-xs mr-3 italic  text-batchBlue">
                      Loading...
                    </span>
                    <div className="spinner "></div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </SettingsLayout>
  );
}

export default Organisation;
